import { Box, Typography } from '@mui/material'
import { LogoBiosferasoftPrimary } from 'assets'
import React from 'react'
import { captionTextStyle } from 'styles'

export const BiosferaSolutions = () => {
  const solutions = [
    {
      url: 'https://marketplace.biosferasoft.com/web-resources/alpaqqa/logo.png',
      angle: 75,
    },
    { url: 'https://marketplace.biosferasoft.com/web-resources/quinde/logo.svg', angle: 35 },
    { url: 'https://marketplace.biosferasoft.com/web-resources/branding/logo.png', angle: 0 },
    { url: 'https://marketplace.biosferasoft.com/web-resources/firmas/logo.png', angle: -35 },
    { url: 'https://marketplace.biosferasoft.com/web-resources/recibidos/logo.png', angle: -75 },
  ]

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Typography
          sx={{ ...captionTextStyle, fontFamily: 'Work Sans', textAlign: 'center', color: 'white' }}
        >
          Powered by
        </Typography>
        <Box
          component={'img'}
          src={LogoBiosferasoftPrimary}
          sx={{
            width: {
              xs: 40,
              sm: 50,
              md: 50,
              lg: 70,
            },
          }}
        />
        <Typography
          sx={{ ...captionTextStyle, fontFamily: 'Work Sans', textAlign: 'center', color: 'white' }}
        >
          biosfera
        </Typography>
        <Typography
          sx={{ ...captionTextStyle, fontFamily: 'Work Sans', textAlign: 'center', color: 'white' }}
        >
          SOFTWARE
        </Typography>

        <Box
          sx={{
            position: 'absolute',
            top: { xs: 70, sm: 50, lg: 130, xl: 70 },
            left: '50%',
            width: 0,
            height: 0,
          }}
        >
          {solutions.map((solution, index) => {
            const angle = solution.angle

            return (
              <Box
                key={index}
                sx={{
                  position: 'absolute',
                  transform: {
                    xs: `translate(-50%, -50%) rotate(${angle}deg) translateY(90px) rotate(${-angle}deg)`,
                    sm: `translate(-50%, -50%) rotate(${angle}deg) translateY(110px) rotate(${-angle}deg)`,
                    md: `translate(-50%, -50%) rotate(${angle}deg) translateY(140px) rotate(${-angle}deg)`,
                    lg: `translate(-50%, -50%) rotate(${angle}deg) translateY(160px) rotate(${-angle}deg)`,
                  },
                  width: { xs: 35, sm: 50, md: 50, lg: 60 },
                  maxWidth: { xs: 35, sm: 50, md: 50, lg: 60 },
                  height: { xs: 35, sm: 50, md: 50, lg: 60 },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  src={solution.url}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
